import { request } from '../auth/client';
import type {
  CustomerCreateInput,
  CustomerCreateResponse,
  CustomerListQuery,
  CustomerRow,
  CustomerUpdateInput,
  PaginatedResponse,
} from '@runik/shared';

export const customersKey = (query?: Partial<CustomerListQuery>) =>
  ['customers', { ...(query ?? {}) }] as const;

export const customerKey = (id: string) => ['customer', id] as const;

export function listCustomers(query: Partial<CustomerListQuery>) {
  const params = new URLSearchParams();
  if (query.page) params.set('page', String(query.page));
  if (query.limit) params.set('limit', String(query.limit));
  if (query.search) params.set('search', query.search);
  if (query.sort) params.set('sort', query.sort);
  if (query.order) params.set('order', query.order);
  return request<PaginatedResponse<CustomerRow>>(`/api/customers?${params.toString()}`);
}

export function getCustomer(id: string) {
  return request<CustomerRow & { deletedAt: string | null }>(`/api/customers/${id}`);
}

export function createCustomer(body: CustomerCreateInput) {
  return request<CustomerCreateResponse>('/api/customers', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updateCustomer(id: string, body: CustomerUpdateInput) {
  return request<CustomerRow>(`/api/customers/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function deleteCustomer(id: string) {
  return request<void>(`/api/customers/${id}`, { method: 'DELETE' });
}

export function reissueInvitation(id: string) {
  return request<{ token: string; activationUrl: string; expiresAt: string }>(
    `/api/customers/${id}/invitations`,
    { method: 'POST' },
  );
}
